export enum ROUTE_ADMIN {
  adminsPage = '/admin-users',
  edit = '/admin-users/:adminId/edit',
  add = '/admin-users/add',
}
